import script from "./UpdateApplicant.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateApplicant.vue?vue&type=script&setup=true&lang=js"

import "./UpdateApplicant.vue?vue&type=style&index=0&id=a2044eca&scoped=true&lang=less"

import exportComponent from "E:\\code\\软著项目\\software\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2044eca"]])

export default __exports__